(function($) {
  //* Make sure JS is enabled
  document.documentElement.className = 'js';

  $(document).ready(() => {
    // When the window has finished loading create our google map below
    google.maps.event.addDomListener(window, 'load', init);

    function init() {
      // Basic options for a simple Google Map
      // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
      const mapOptions = {
        // How zoomed in you want the map to start at (always required)
        zoom: 13,

        disableDefaultUI: true,

        // The latitude and longitude to center the map (always required)
        center: new google.maps.LatLng(43.710143, 7.2593), // New York

        // How you would like to style the map.
        // This is where you would paste any style found on Snazzy Maps.
        styles: [
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [{ color: '#00B6BC' }],
          },
          {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [{ color: '#002F56' }],
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{ color: '#29768a' }, { lightness: -37 }],
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [{ color: '#406d80' }],
          },
          {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [{ color: '#406d80' }],
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [
              { visibility: 'on' },
              { color: '#3e606f' },
              { weight: 2 },
              { gamma: 0.84 },
            ],
          },
          { elementType: 'labels.text.fill', stylers: [{ color: '#ffffff' }] },
          {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [{ weight: 0.6 }, { color: '#1a3541' }],
          },
          { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [{ color: '#2c5a71' }],
          },
        ],
      };

      // Get the HTML DOM element that will contain your map
      // We are using a div with id="map" seen below in the <body>
      const mapElement = document.getElementById('map');

      // Create the Google Map using our element and options defined above
      const map = new google.maps.Map(mapElement, mapOptions);

      const icon = {
        url: `${templateUrl}/dist/images/marker.png`,
      };

      // Let's also add a marker while we're at it
      new google.maps.Marker({
        position: new google.maps.LatLng(43.710143, 7.2593),
        map,
        title: 'Digital Swing',
        icon,
      });
    }
    $('#map').click(() => {
      $('#map > div').css('pointer-events', 'auto');
    });

    $('#map').mouseleave(() => {
      $('#map > div').css('pointer-events', 'none');
    });
  });
})(jQuery);
